import type { I18nFn } from '#/i18n/types/I18nFn';

export function LINE_ITEM_TYPES(i18n: I18nFn) {
  return [
    {
      id: 'JOB',
      name:
        /* TRANSLATORS: line item type */
        i18n('Job Listing'),
    },
    {
      id: 'INTERNSHIP',
      name:
        /* TRANSLATORS: line item type */
        i18n('Internship Listing'),
    },
    {
      id: 'CREDITS',
      name:
        /* TRANSLATORS: line item type */
        i18n('Credit Pack'),
    },
    {
      id: 'JOB_PACK_3',
      name:
        /* TRANSLATORS: line item type */
        i18n('3 Job Pack'),
    },
    {
      id: 'JOB_PACK_10',
      name:
        /* TRANSLATORS: line item type */
        i18n('10 Job Pack'),
    },
    {
      id: 'JOB_PACK_20',
      name:
        /* TRANSLATORS: line item type */
        i18n('20 Job Pack'),
    },
    {
      id: 'JOB_PACK_25',
      name:
        /* TRANSLATORS: line item type */
        i18n('25 Job Pack'),
    },
    {
      id: 'JOB_PACK_30',
      name:
        /* TRANSLATORS: line item type */
        i18n('30 Job Pack'),
    },
    {
      id: 'JOB_PACK_50',
      name:
        /* TRANSLATORS: line item type */
        i18n('50 Job Pack'),
    },
    {
      id: 'JOB_PACK_100',
      name:
        /* TRANSLATORS: line item type */
        i18n('100 Job Pack'),
    },
    {
      id: 'JOB_PACK_500',
      name:
        /* TRANSLATORS: line item type */
        i18n('500 Job Pack'),
    },
    {
      id: 'INTERNSHIP_PACK_10',
      name:
        /* TRANSLATORS: line item type */
        i18n('10 Internship Pack'),
    },
    {
      id: 'FAIR',
      name:
        /* TRANSLATORS: line item type */
        i18n('Grad Fair Exhibitor'),
    },
    {
      id: 'LISTING_PROMOTION',
      name:
        /* TRANSLATORS: line item type */
        i18n('Listing Promotion'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_SMALL',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunity - 5 Mile Radius'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_MEDIUM',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunity - 15 Mile Radius'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_LARGE',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunity - 50 Mile Radius'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_NWIDE',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunity - Nationwide'),
    },
    {
      id: 'MEMBERSHIP',
      name:
        /* TRANSLATORS: line item type */
        i18n('Idealist Membership'),
    },
    {
      id: 'ORG_MEMBERSHIP_BUY',
      name:
        /* TRANSLATORS: line item type */
        i18n('1-Year Membership'),
    },
    {
      id: 'ORG_MEMBERSHIP_RENEW',
      name:
        /* TRANSLATORS: line item type */
        i18n('1-Year Membership Renewal'),
    },
    {
      id: 'VOLOP',
      name:
        /* TRANSLATORS: line item type */
        i18n('Volunteer Opportunity'),
    },
    {
      id: 'DONATION',
      name:
        /* TRANSLATORS: line item type */
        i18n('Donation'),
    },
  ] as const;
}

export function LINE_ITEM_TYPES_PLURAL(i18n: I18nFn) {
  return [
    {
      id: 'JOB',
      name:
        /* TRANSLATORS: line item type */
        i18n('Job Listings'),
    },
    {
      id: 'INTERNSHIP',
      name:
        /* TRANSLATORS: line item type */
        i18n('Internship Listings'),
    },
    {
      id: 'CREDITS',
      name:
        /* TRANSLATORS: line item type */
        i18n('Credit Packs'),
    },
    {
      id: 'JOB_PACK_10',
      name:
        /* TRANSLATORS: line item type */
        i18n('10 Job Packs'),
    },
    {
      id: 'JOB_PACK_20',
      name:
        /* TRANSLATORS: line item type */
        i18n('20 Job Packs'),
    },
    {
      id: 'JOB_PACK_25',
      name:
        /* TRANSLATORS: line item type */
        i18n('25 Job Packs'),
    },
    {
      id: 'JOB_PACK_30',
      name:
        /* TRANSLATORS: line item type */
        i18n('30 Job Packs'),
    },
    {
      id: 'JOB_PACK_50',
      name:
        /* TRANSLATORS: line item type */
        i18n('50 Job Packs'),
    },
    {
      id: 'JOB_PACK_100',
      name:
        /* TRANSLATORS: line item type */
        i18n('100 Job Packs'),
    },
    {
      id: 'JOB_PACK_500',
      name:
        /* TRANSLATORS: line item type */
        i18n('500 Job Packs'),
    },
    {
      id: 'INTERNSHIP_PACK_10',
      name:
        /* TRANSLATORS: line item type */
        i18n('10 Internship Packs'),
    },
    {
      id: 'FAIR',
      name:
        /* TRANSLATORS: line item type */
        i18n('Grad Fair Exhibitors'),
    },
    {
      id: 'GRAD_PROGRAM',
      name:
        /* TRANSLATORS: line item type */
        i18n('Grad Programs'),
    },
    {
      id: 'VOLOP',
      name:
        /* TRANSLATORS: line item type */
        i18n('Volunteer Opportunities'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_SMALL',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunities - 5 Mile Radius'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_MEDIUM',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunities - 15 Mile Radius'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_LARGE',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunities - 50 Mile Radius'),
    },
    {
      id: 'PROMOTED_VOLOP_RADIUS_NWIDE',
      name:
        /* TRANSLATORS: line item type */
        i18n('Promoted Volunteer Opportunities - Nationwide'),
    },
    {
      id: 'ORG_MEMBERSHIP_BUY',
      name:
        /* TRANSLATORS: line item type */
        i18n('1-Year Memberships'),
    },
    {
      id: 'ORG_MEMBERSHIP_RENEW',
      name:
        /* TRANSLATORS: line item type */
        i18n('1-Year Membership Renewals'),
    },
    {
      id: 'GRAD_PROGRAM',
      name:
        /* TRANSLATORS: line item type */
        i18n('Grad Program'),
    },
    {
      id: 'DONATION',
      name:
        /* TRANSLATORS: line item type */
        i18n('Donations'),
    },
  ];
}
